import { FC, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import App from '../App'

const PinyinModule = lazy(() => import('../pages/pinyin/PinyinModule'))
const PinyinTable = lazy(() => import('../pages/pinyin/PinyinTable'))
const PinyinLearning = lazy(() => import('../pages/pinyin/PinyinLearning'))
const PinyinIndex = lazy(() => import('../pages/pinyin/PinyinIndex'))
const ResourcesDownload = lazy(() => import('../pages/ResourcesDownload'))
const ToneLearning = lazy(() => import('../pages/pinyin/ToneLearning'))
const ProductInfo = lazy(() => import('../pages/about/ProductInfo'))
const FlashcardGallery = lazy(() => import('../pages/chengyu/FlashcardGallery'))
const TermsOfService = lazy(() => import('../pages/about/TermsOfService'))
const PrivacyPolicy = lazy(() => import('../pages/about/PrivacyPolicy'))
const ContactUs = lazy(() => import('../pages/about/ContactUs'))
const ChengyuLearning = lazy(() => import('../pages/chengyu/ChengyuLearning'))
const StageLearning = lazy(() => import('../pages/chengyu/StageLearning'))
const IdiomDetail = lazy(() => import('../pages/chengyu/IdiomDetail'))
const ChengyuDictionary = lazy(() => import('../pages/chengyu/ChengyuDictionary'))
const GamesHome = lazy(() => import('../pages/chengyu/games/GamesHome'))
const PuzzleGame = lazy(() => import('../pages/chengyu/games/puzzle/PuzzleGame'))
const FillGame = lazy(() => import('../pages/chengyu/games/fill/FillGame'))
const SolitaireGame = lazy(() => import('../pages/chengyu/games/solitaire/SolitaireGame'))
const CharacterFreeLearn = lazy(() => import('../pages/character/CharacterFreeLearn'))
const CharacterStageList = lazy(() => import('../pages/character/CharacterStageList'))
const HWCharacterStageList = lazy(() => import('../pages/character/HWCharacterStageList'))
const CharacterDetail = lazy(() => import('../pages/character/CharacterDetail'))
const GoalLearningContainer = lazy(() => import('../pages/character/goal/GoalLearningContainer'))
const DailyLearning = lazy(() => import('../pages/character/daily/DailyLearning'))
const VocabularyBook = lazy(() => import('../pages/character/VocabularyBook'))
const LearnedWordsList = lazy(() => import('../pages/character/LearnedWordsList'))
const MasteredWordsList = lazy(() => import('../pages/character/MasteredWordsList'))
const VocabLearningContainer = lazy(() => import('../pages/vocab/goal/VocabLearningContainer'))
const VocabDailyLearning = lazy(() => import('../pages/vocab/daily/VocabDailyLearning'))
const VocabDifficultWords = lazy(() => import('../pages/vocab/VocabDifficultWords'))
const VocabLearnedWords = lazy(() => import('../pages/vocab/VocabLearnedWords'))
const VocabMasteredWords = lazy(() => import('../pages/vocab/VocabMasteredWords'))

const AppRouter: FC = () => {
  return (
    <Routes>
      <Route path="/pinyin-learning" element={<App><PinyinLearning /></App>} />
      <Route path="/pinyin-module" element={<App><PinyinModule /></App>} />
      <Route path="/pinyin-table" element={<App><PinyinTable /></App>} />
      <Route path="/pinyin-index" element={<App><PinyinIndex /></App>} />
      <Route path="/resources-download" element={<App><ResourcesDownload /></App>} />
      <Route path="/tone-learning" element={<App><ToneLearning /></App>} />
      <Route path="/product-info" element={<App><ProductInfo /></App>} />
      <Route path="/terms" element={<App><TermsOfService /></App>} />
      <Route path="/privacy" element={<App><PrivacyPolicy /></App>} />
      <Route path="/contact" element={<App><ContactUs /></App>} />
      <Route path="/chengyu-learning" element={<App><ChengyuLearning /></App>} />
      <Route path="/chengyu-flashcards" element={<App><FlashcardGallery /></App>} />
      <Route path="/chengyu-dictionary" element={<App><ChengyuDictionary /></App>} />
      <Route path="/chengyu/games" element={<App><GamesHome /></App>} />
      <Route path="/chengyu/games/puzzle" element={<App><PuzzleGame /></App>} />
      <Route path="/chengyu/games/fill" element={<App><FillGame /></App>} />
      <Route path="/chengyu/games/solitaire" element={<App><SolitaireGame /></App>} />
      <Route path="/chengyu/stage/:stage" element={<App><StageLearning /></App>} />
      <Route path="/chengyu/idiom/:idiomWord" element={<App><IdiomDetail /></App>} />
      <Route path="/characters/free" element={<App><CharacterFreeLearn /></App>} />
      <Route path="/characters/recognize" element={<App><CharacterStageList /></App>} />
      <Route path="/characters/recognize/hsk/:level" element={<App><CharacterStageList /></App>} />
      <Route path="/characters/recognize/hsk/:level/detail/:char" element={<App><CharacterDetail /></App>} />
      <Route path="/characters/recognize/detail/:char" element={<App><CharacterDetail /></App>} />
      <Route path="/characters/handwrite" element={<App><HWCharacterStageList /></App>} />
      <Route path="/characters/handwrite/hsk/:level" element={<App><HWCharacterStageList /></App>} />
      <Route path="/characters/handwrite/hsk/:level/detail/:char" element={<App><CharacterDetail mode="handwrite" /></App>} />
      <Route path="/characters/handwrite/detail/:char" element={<App><CharacterDetail mode="handwrite" /></App>} />
      <Route path="/characters/goal" element={<App><GoalLearningContainer /></App>} />
      <Route path="/characters/goal/learn" element={<App><DailyLearning /></App>} />
      <Route path="/characters/goal/review" element={<App><DailyLearning initialView="review" /></App>} />
      <Route path="/vocabulary-book" element={<App><VocabularyBook skillType="recognize" /></App>} />
      <Route path="/learned-words" element={<App><LearnedWordsList /></App>} />
      <Route path="/mastered-words" element={<App><MasteredWordsList /></App>} />
      <Route path="/vocab" element={<App><VocabLearningContainer /></App>} />
      <Route path="/vocab/learn" element={<App><VocabDailyLearning /></App>} />
      <Route path="/vocab/difficult-words" element={<App><VocabDifficultWords /></App>} />
      <Route path="/vocab/learned-words" element={<App><VocabLearnedWords /></App>} />
      <Route path="/vocab/mastered-words" element={<App><VocabMasteredWords /></App>} />
      <Route path="*" element={<App />} />
    </Routes>
  )
}

export default AppRouter
